export default {
  list(state) {
    return state.assets;
  },
};
